import { useCallback, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { PRODUCT_IDS } from "../productContext";
import { resolveAgentDashboardBase } from "../routeLocale";
import { useProductContext } from "../providers/ProductContextProvider";

/**
 * Agent dashboard base path for current locale context.
 * Hebrew Sprint 1–4: /p/dashboard (legacy alias).
 */
export function useDashboardBasePath(options = {}) {
  const { locale, product, isLegacyAlias } = useProductContext();
  const useLegacyAlias = options.useLegacyAlias ?? isLegacyAlias ?? true;

  return useMemo(() => {
    if (product !== PRODUCT_IDS.AGENT) {
      return resolveAgentDashboardBase(locale, { useLegacyAlias });
    }
    return resolveAgentDashboardBase(locale, { useLegacyAlias });
  }, [locale, product, useLegacyAlias]);
}

export function useDashboardBasePathForLocale(locale, options = {}) {
  const useLegacyAlias = options.useLegacyAlias !== false;
  return resolveAgentDashboardBase(locale, { useLegacyAlias });
}

export function useIsAgentDashboardPath() {
  const location = useLocation();
  return useMemo(() => {
    const p = location.pathname;
    return (
      p.startsWith("/p/dashboard") ||
      p.startsWith("/he/dashboard") ||
      p.startsWith("/en/dashboard") ||
      p.startsWith("/el/dashboard")
    );
  }, [location.pathname]);
}

export default useDashboardBasePath;
